import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import React, { useRef, useState } from 'react';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import { Icon } from '@iconify/react';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  menuItem: {
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    },
    minHeight: '20px',
    borderRadius: '8px',
    marginInline: theme.spacing(1)
  }
}));

export default function FotaMoreMenu({ handleClicks }) {
  const classes = useStyles();
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <IconButton data-testid="fota-more-menu" ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' }
        }}
        sx={{
          '& .MuiListItemText-root > .MuiTypography-root': {
            color: '#000',
            fontWeight: 600,
            fontStyle: 'normal'
          }
        }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          onClick={() => {
            setIsOpen(false);
            handleClicks('apply_fota');
          }}
          sx={{ color: 'text.secondary' }}
          className={classes.menuItem}
        >
          {/* <ListItemIcon>
            <EditIcon />
          </ListItemIcon> */}
          <ListItemText primary="Apply FOTA" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>
        {/* <MenuItem
          onClick={() => {
            setIsOpen(false);
            handleClicks('delete_user');
          }}
          sx={{ color: 'text.secondary' }}
          className={classes.menuItem}
        >
          <ListItemIcon>
            <RemoveCircleOutlineOutlinedIcon sx={{ color: '#C30A0A' }} />
          </ListItemIcon>
          <ListItemText primary="Delete" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem> */}
      </Menu>
    </>
  );
}
